import { LOGIN_FAIL, LOGIN_REQUEST, LOGIN_SUCCESS } from "../constant"

const initialState = {
  authData: {},
  isLoading: false,
  status: '',
  message: ''
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_REQUEST:
      return {
        ...state,
        authData: {},
        isLoading: true
      }
    case LOGIN_SUCCESS:
      return {
        ...state,
        authData: {},
        isLoading: false,
        status:200,
        message: 'Login Success'
      }
    case LOGIN_FAIL:
      return {
        ...state,
        authData: {},
        isLoading: false,
        status:action?.payload?.response?.data?.statusCode,
        message: action?.payload?.response?.data?.msg
      }
    case 'RESET_LOGIN':
      return {
        ...state,
        authData: {},
        isLoading: false,
        status:0,
        message: 'reset'
      }
    default:
      return state;
  }
}

export { authReducer }